var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FF0000",
    fillOpacity: 0.22
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5459 23.9545C25.7572 24.1658 25.876 24.4525 25.876 24.7513C25.876 25.0502 25.7572 25.3369 25.5459 25.5482C25.3346 25.7596 25.0479 25.8783 24.749 25.8783C24.4501 25.8783 24.1635 25.7596 23.9521 25.5482L18 19.5942L12.0459 25.5463C11.8346 25.7577 11.5479 25.8764 11.249 25.8764C10.9501 25.8764 10.6635 25.7577 10.4521 25.5463C10.2408 25.335 10.1221 25.0484 10.1221 24.7495C10.1221 24.4506 10.2408 24.1639 10.4521 23.9526L16.4062 18.0004L10.454 12.0463C10.2427 11.835 10.1239 11.5484 10.1239 11.2495C10.1239 10.9506 10.2427 10.6639 10.454 10.4526C10.6654 10.2413 10.952 10.1225 11.2509 10.1225C11.5498 10.1225 11.8364 10.2413 12.0478 10.4526L18 16.4067L23.954 10.4517C24.1654 10.2403 24.452 10.1216 24.7509 10.1216C25.0498 10.1216 25.3364 10.2403 25.5478 10.4517C25.7591 10.663 25.8778 10.9496 25.8778 11.2485C25.8778 11.5474 25.7591 11.8341 25.5478 12.0454L19.5937 18.0004L25.5459 23.9545Z",
    fill: "#FF2F2F",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.601f682281d35428b064e66e4d33ae04.svg";
export { ForwardRef as ReactComponent };